import {useQuery} from 'react-query';
import {campaignService} from 'src/shared/services/campaigns';

export const useGetCampaignCustomers = (id: string) => {
  return useQuery(['campaigns-cus'], () =>
    campaignService.campaignCustomers(id),
  );
};
